import { IMessageCreatorResult } from '../../../repositories/demand/entities/base_creator_result_message/MessageCreatorResult';
import { IPersonalMessageCreatorResult } from '../../../repositories/demand/entities/creator_result_personal_message/PersonalMessageCreatorResult';

export const isMessageSubmitFormResponse = (
  response: IMessageCreatorResult | IPersonalMessageCreatorResult,
): response is IMessageCreatorResult => {
  return 'sentMessageFromCian' in response;
};
